import { render, staticRenderFns } from "./SupplierInvoiceView.vue?vue&type=template&id=433b208f&"
import script from "./SupplierInvoiceView.vue?vue&type=script&lang=js&"
export * from "./SupplierInvoiceView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports